import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
} from "@mui/material";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import Axios from "../Axios";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
const ContactManagement = () => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState();
  const [publishDate, setPublishDate] = useState(
    moment(new Date()).format("DD-MM-YYYY")
  );
  const [allContact, setAllContact] = useState();
  const [userId, setUserId] = useState();
  const [opendel, setOpenDel] = useState(false);
  const [type, setType] = useState();
  const [status, setStatus] = useState(true);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const [img, setImg] = useState("");

  useEffect(() => {
    fetchAllBlog(0, "");
  }, []);

  const fetchAllBlog = (page, search) => {
    let data = {
      page: page,
      searchChar: search,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-contact", data, {
      headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
    })
      .then((resp) => {
        setAllContact(resp?.data?.data);
        setCount(resp?.data?.totalBlogs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    download: false,
    selectableRows: false,
    filter: false,
    viewColumns: false,
    serverSide: true,
    count: count,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllBlog(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllBlog(page, searchText);
      setSearch(searchText);
    },
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "phone",
      label: "Phone Number",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "updatedAt",
      label: "Publish Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allContact[dataIndex]?.updatedAt).format("DD-MM-YYYY")}
            </div>
          );
        },
      },
    },
    {
      name: "display",
      label: "Connect Status",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <p
              className={
                allContact[dataIndex]?.status
                  ? "active-user fs-14 fw-600 m-1"
                  : "inactive fs-14 fw-600 m-1"
              }
            >
              {allContact[dataIndex]?.status ? "Connected" : "Not Connected"}
            </p>
          );
        },
      },
    },

    {
      name: "Action",
      label: "Action",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {/* <Tooltip title="View">
                <IconButton
                  aria-label="View Contact"
                  onClick={() => handleOpen(allContact[dataIndex], "view")}
                >
                  <RemoveRedEyeOutlinedIcon className="icon-size" />
                </IconButton>
              </Tooltip> */}

              <>
                <Tooltip
                  title={
                    allContact[dataIndex]?.status
                      ? "Not Connected"
                      : "Connected"
                  }
                >
                  <IconButton
                    aria-label="sss"
                    onClick={() =>
                      handleOpen(
                        allContact[dataIndex]._id,
                        "block",
                        allContact[dataIndex]?.status
                      )
                    }
                  >
                    <BlockOutlinedIcon className="fs-20" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton
                    aria-label="Delete Contact"
                    onClick={() =>
                      handleOpen(allContact[dataIndex]._id, "delete")
                    }
                  >
                    <DeleteOutlineOutlinedIcon className="fs-20 delete-icon" />
                  </IconButton>
                </Tooltip>
              </>
            </>
          );
        },
      },
    },
  ];
  // Function for dialog open close
  const handleOpen = (userid, type, status) => {
    if (type === "delete") {
      setUserId(userid);
      setOpenDel(true);
    } else if (type === "block") {
      setUserId(userid);
      setOpenDel(true);
      setStatus(status);
      setType("block");
    } else if (type === "edit") {
      setName(userid?.title);
      setUserId(userid._id);
      setType("edit");
      setOpen(true);
      setPublishDate(moment(userid?.publishedAt).format("DD-MM-YYYY"));
    } else if (type === "view") {
      setName(userid?.title);
      setPublishDate(moment(userid?.publishedAt).format("DD-MM-YYYY"));

      setUserId(userid._id);
      setImg(userid?.image);
      setType("view");
      setOpen(true);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setOpenDel(false);
    setType("");
    setName("");
    setUserId("");
    setStatus(true);
    setPublishDate(moment(new Date()).format("DD-MM-YYYY"));
  };

  // Function to delete the user
  const handleDelete = () => {
    let api;
    if (type === "block") {
      api = "update-contact";
    } else {
      api = "delete-contact";
    }
    Axios.post(
      process.env.REACT_APP_BACKEND + api,
      {
        id: userId,
      },
      {
        headers: { Authorization: `Bearer ${localStorage?.getItem("token")}` },
      }
    )
      .then((resp) => {
        fetchAllBlog(0, "");
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  return (
    <div className="p-4">
      <div
        className="mb-5"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2 className="primary_title text-start about_heading m-2 mb-3">
          Contact Management
        </h2>
      </div>
      <MUIDataTable
        title={"Contact List"}
        data={allContact}
        columns={columns}
        options={options}
      />
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
        maxWidth="xl"
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>
            {" "}
            {type === "edit"
              ? "Edit Contact Details"
              : type === "view"
              ? "View Contact"
              : "Create Contact"}
          </h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          {type === "view" ? (
            <>
              <div className="viewDetials">
                <h3 className="view-style fs-20 fw-600 mb-4">{name}</h3>
                <p className="fs-12 fw-500 ms-2 mb-2">Publish Date</p>
                <div className="capsule published">{publishDate}</div>
                <div>
                  <img src={img} alt="" style={{ width: "25%" }} />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </DialogContent>
        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          {type !== "view" ? (
            <Button variant="contained" className="btn ms-4">
              {type === "edit" ? "Submit" : "Create"}
            </Button>
          ) : (
            <></>
          )}
        </div>
      </Dialog>
      {/* ------------------------Delete Contact---------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>
            {type === "block"
              ? status
                ? " Not Connected"
                : "Connected"
              : "Delete"}
          </h3>

          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14">
            {type === "block"
              ? status
                ? "Are you sure you want to change the  status to Not Connected?"
                : "Are you sure you want to change the  status to Connected?"
              : "Are you sure you want to delete the Contact?"}
          </p>
        </DialogContent>
        <div className="text-center mt-4 mb-4" dividers>
          <Button
            variant="outlined"
            className="borderbtn"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn ms-4"
            onClick={handleDelete}
          >
            {type === "block"
              ? status
                ? " Not Connect "
                : " Connect "
              : "Delete "}
          </Button>
        </div>
      </Dialog>
    </div>
  );
};
export default ContactManagement;
